import { render, staticRenderFns } from "./SchedulesTable.vue?vue&type=template&id=35ab0d3a&scoped=true"
import script from "./SchedulesTable.vue?vue&type=script&lang=ts"
export * from "./SchedulesTable.vue?vue&type=script&lang=ts"
import style0 from "./SchedulesTable.vue?vue&type=style&index=0&id=35ab0d3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ab0d3a",
  null
  
)

export default component.exports